module.exports = __webpack_public_path__ + "media/images/pc/specials/fair_event/gallery/tmb_gallery3-663a5a9d90c1ee39c2775c2d202274ad.jpg";